var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubtraction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.88,
    height: 20.907,
    viewBox: "0 0 20.88 20.907",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M-251.442-2272.095h-3.3l13.645-13.661v3.3l-10.347,10.36Zm8.017,0h-2.33l4.661-4.667v2.334a2.273,2.273,0,0,1-.688,1.644A2.27,2.27,0,0,1-243.426-2272.095Zm-16.907-.094h0a2.38,2.38,0,0,1-1.047-.593,2.41,2.41,0,0,1-.594-1.05L-242.831-2293a2.342,2.342,0,0,1,1.654,1.645Z",
    transform: "translate(261.975 2293.002)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtraction);
export default __webpack_public_path__ + "static/media/subtraction.35b1a04498c6372672a314c53dd7440f.svg";
export { ForwardRef as ReactComponent };